"use strict";
const vue = require("vue");
const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  viewBox: "0 0 24 24"
};
const _hoisted_2 = /* @__PURE__ */ vue.createElementVNode("path", {
  d: "M7.667 2.103c2.042 0 3.792 1.334 4.417 3.188l4.104.021c.125 0 .229.042.312.125l4.291 4.292a.305.305 0 0 1 .105.292v10.562c0 .73-.583 1.313-1.312 1.313H7.479a1.308 1.308 0 0 1-1.313-1.313v-9.396A4.686 4.686 0 0 1 3 6.77a4.673 4.673 0 0 1 4.667-4.667zm4.624 4.065c.02.208.042.395.042.603a4.673 4.673 0 0 1-4.667 4.667c-.208 0-.416-.02-.625-.042v9.187c0 .251.188.438.438.438h12.125c.25 0 .438-.188.438-.438V10.481h-3.854a.428.428 0 0 1-.438-.438V6.189zm-.437 8.04a.45.45 0 0 1 .73-.02l1.625 2.187c.166.23.479.25.666.063l.52-.501c.188-.187.5-.146.667.063l1.875 2.645a.434.434 0 0 1-.354.688H9.458a.433.433 0 0 1-.375-.667zm5.73-.728c0 1.5-2.25 1.5-2.25 0 0-1.501 2.25-1.501 2.25 0zM7.665 2.98a3.804 3.804 0 0 0-3.791 3.79 3.804 3.804 0 0 0 3.791 3.792 3.805 3.805 0 0 0 3.792-3.791 3.805 3.805 0 0 0-3.792-3.792zm8.959 3.833v2.791h2.79l-2.79-2.791zM9.312 7.999c.25 0 .438.209.438.438 0 .25-.188.438-.417.439H6.02a.441.441 0 0 1-.438-.438A.44.44 0 0 1 6.02 8zM7.54 4.187c.063-.083.208-.083.271 0l1.083 1.438c.084.104 0 .27-.146.27h-.583v1.563a.143.143 0 0 1-.146.146h-.708a.142.142 0 0 1-.145-.146V5.896h-.584c-.146 0-.229-.167-.125-.271z",
  fill: "#000",
  "fill-rule": "nonzero"
}, null, -1);
const _hoisted_3 = [
  _hoisted_2
];
function render(_ctx, _cache) {
  return vue.openBlock(), vue.createElementBlock("svg", _hoisted_1, _hoisted_3);
}
const UploadIcon = { render };
exports.UploadIcon = UploadIcon;
